import { createBrowserRouter } from 'react-router-dom';
import DashBoardLayout from 'layouts/DashBoardLayout';
import ReferralsListPage from 'pages/ReferralsListPage';
import MerchantDetailsPage from 'pages/MerchantDetailsPage';
import CreateLeadPage from 'pages/CreateLeadPage';
import LeadsListPage from 'pages/LeadsListPage';
import UpdateLeadPage from 'pages/UpdateLeadPage';
import PayoutReportsListPage from 'pages/PayoutReportsListPage';
import NewPayoutReportListPage from 'pages/NewPayoutReportListPage';
// import ReportsListPage from 'pages/ReportsListPage';
import CustomReportsListPage from 'pages/CustomReportsListPage';
// import CustomReportsListPage2 from 'pages/CustomReportsListPage2';
import TransactionListPage from 'pages/TransactionListPage';
import PageNotFound from 'components/PageNotFound';
import SomethingWentWrong from 'components/SomethingWentWrong';
import Settings from 'pages/SettingsPage';
import DashBoardPage from 'pages/DashBoardPage';
import GTVReferralsListPage from 'pages/GTVReferralsListPage';
import TeamPage from 'pages/TeamsPage/TeamsPage';
import NoPermission from 'pages/NoPermission/NoPermission';
import PayoutMonthReportTabs from 'pages/NewPayoutReportListPage/Tabs/PayoutReportTab/PayoutMonthReportTabs';
import RequireAuth from './RequireAuth';

// router configuration for RouterProvider element in react-router
const RoutesConfig = createBrowserRouter([
  {
    // common layout for all required pages
    element: <RequireAuth />, // SSO component act act as react wrapper component using React Router
    errorElement: <SomethingWentWrong />,
    children: [
      {
        children: [
          {
            path: '/',
            element: <p>This is required for routing</p>
          },
          {
            element: <DashBoardLayout />,
            children: [
              {
                path: '/dashboard',
                element: <DashBoardPage />
              },
              {
                path: '/referrals',
                children: [
                  {
                    index: true,
                    element: <ReferralsListPage />
                  },
                  {
                    path: 'referral-gtv',
                    element: <GTVReferralsListPage />
                  },
                  {
                    path: 'details/:id',
                    element: <MerchantDetailsPage />
                  }
                ]
              },
              {
                path: '/transactions',
                element: <TransactionListPage />
              },
              {
                path: '/leads',
                children: [
                  {
                    index: true,
                    element: <LeadsListPage />
                  },
                  {
                    path: 'create',
                    element: <CreateLeadPage />
                  },
                  {
                    path: 'update/:id',
                    element: <UpdateLeadPage />
                  }
                ]
              },
              // {
              //   path: '/invoices',
              //   element: <InvoicesListPage />
              // },
              {
                path: '/payout-reports',
                children: [
                  {
                    index: true,
                    element: <NewPayoutReportListPage />
                  },
                  {
                    path: 'reports/:id',
                    element: <PayoutMonthReportTabs />
                  }
                ]
              },
              {
                path: '/payout-reports2',
                element: <PayoutReportsListPage />
              },
              {
                path: 'custom-reports',
                element: <CustomReportsListPage />
              },
              {
                path: '/settings',
                element: <Settings />
              },
              {
                path: '/teams',
                element: <TeamPage />
              },
              {
                path: '/no-permission',
                element: <NoPermission />
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    element: <PageNotFound />
  }
]);

export default RoutesConfig;
